import { useEffect, useState } from "react";
import styles from "./OwnerTransferModal.module.css";
import axios from "../../../utils/api/axios";
import {  IAM_SERVER_TENANT, IAM_SERVER_TENANT_USER } from "../../../utils/Config";
import { DialogEnum, showDialog } from "../../../utils/dialog/Dialog";
import { getCookie } from "../../../utils/cookies/cookies";

const OwnerTransferModal = ({ tenantId, tenantName, tenantUserId, onClose }) => {
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [oldTenantUser, setOldTenantUser] = useState({});

  const fetchData = async () => {

    try {

      // 필수 조건: 날짜 범위 조건
      const conditions = [
          { field: "tenantId", operator: "EQUALS", value: tenantId },
          { field: "tenantType", operator: "NOT_EQUALS", value: 'owner' }
      ];

      // 최종 params 구성
      const params = {
          sortField: ['tenantType'],
          sortOrder: ['asc'],
          operator: "AND",
          conditions
      };

      const resdata = await axios.post(`${IAM_SERVER_TENANT_USER}/all`, params);
      const { data, recordsTotal } = resdata.data.data;

      const profileIds = data.map(item => item.profileId);

      const tenantUserUrl = IAM_SERVER_TENANT_USER + "/get/tenant";
      const tenantUserParams = {
          tenantId: tenantId,
          profileIds: profileIds
      };            

      const tenantUserRes = await axios.post(tenantUserUrl, tenantUserParams);

      // 두 데이터
      const mainList = data; // 원본 테넌트 유저 리스트
      const tenantUserExtraList = tenantUserRes.data.data; // 확장 정보

      // profileId 기준으로 병합
      const mergedData = mainList.map(item => {
      const extra = tenantUserExtraList.find(extraItem => extraItem.profileId === item.profileId);
      return {
          ...item,
          ...(extra || {}) // 확장 정보가 있다면 병합, 없으면 무시
      };
      });
      
      setUsers(mergedData);

    } catch (error) {
      showDialog(DialogEnum.DEFAULT, "실패", "오너 유저 정보를 불러오지 못했습니다.");
      onClose();
    }
  }

  useEffect(() => {
    fetchData();
  }, [tenantId]);

  const handleSubmit = () => {
    if (!selected) {
      showDialog(DialogEnum.DEFAULT, "알림", "소유주로 전환할 유저를 선택해주세요.");
      return;
    }

    const url = `${IAM_SERVER_TENANT}/requestOwnerTransfer`;
    const payload = {
      tenantId,
      tenantName,
      newOwnerTenantUserId: selected.tenantUserId,
      newOwnerUnifiedProfileId: selected.unifiedProfileId,
      oldOwnerTenantUserId: tenantUserId,
      oldOwnerUnifiedProfileId: getCookie("user_id"),
      status: 'pending'
    };

    axios.post(url, payload)
      .then(res => {
        if(res.data.code === 400){
            showDialog(DialogEnum.SUCCESS, "신청 실패", res.data.message, onClose);
        }else if(res.data.code === 200){
            showDialog(DialogEnum.SUCCESS, "신청 완료", "관리자의 승인이 필요합니다.", onClose);
        }
      })
      .catch(() => {
        showDialog(DialogEnum.FAIL, "실패", "소유주 전환 신청에 실패했습니다.");
        onClose();
      });
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2>소유주 전환 신청</h2>
        <p className={styles.info}>※ 소유주 전환은 관리자 승인이 필요합니다.</p>

        <ul className={styles.userList}>
          {users.filter(u => u.tenantType !== "owner").map(user => (
            <li
              key={user.profileId}
              className={selected?.profileId === user.profileId ? styles.selected : ""}
              onClick={() => setSelected(user)}
            >
              <img src={user.profileImgUrl || "https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt="profile" />
              <div>
                <strong>{user.profileName}</strong> <strong>{`(${user.tenantType})`}</strong>
                <p>{user.unifiedProfileId}</p>
              </div>
            </li>
          ))}
        </ul>

        <div className={styles.btnGroup}>
          <button className={styles.cancelBtn} onClick={onClose}>취소</button>
          <button className={styles.confirmBtn} onClick={handleSubmit}>전환 신청</button>
        </div>
      </div>
    </div>
  );
};

export default OwnerTransferModal;
